import { EMPTY_OBJECT } from '../../../../../constants/common'
import { isStaffUser } from '../../../../../utils/user'
import {
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER,
} from '../../RequestWizardForm.constants'

export function getFlatApiParams(values) {
  const user = values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER] || EMPTY_OBJECT

  return {
    building: values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING]?.value,
    inhabitant: !isStaffUser(user)
      ? values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER]?.value
      : undefined,
  }
}
